import { Breadcrumb, Button, Card, Col, Flex, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg"
import TableAntd from "components/elements/Table";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import SSOPaymentReportModal from "../reportModal/SSOPaymentReportModal";

const SSOPaymentReportComponent = ({
    positionOptions = [],
    departmentOptions = [],
    reportSSOPayrollList = [],
    isModalOpen = false,
    showReport,
    pagination,
    handleSearch = () => { },
    onChange = () => { },
    setIsModalOpen = () => { },
    showModal = () => { },
    exportSSOPayrollReport = () => { },
    branchOptions = [],
}) => {
    const { t, i18n } = useTranslation();

    const columns = [
        {
            title: <div className="text-table">{t('common.index')}</div>,
            dataIndex: "index",
            key: "index",
            align: "center",
            width: 90,
            render: (_, record, idx) => {
                return <span style={{
                    color: "#42526D",
                    backgroundColor: "#F5F6F7",
                    borderRadius: "20px",
                    width: "max-content",
                    height: "30px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "auto",
                    padding: "8px"
                }}>
                    {(pagination.pageNo - 1) * pagination.size + idx + 1}</span>;
            },
        },
        {
            title: <div className="text-table">{t('report.employeeNo')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "center",
            render: (_, record) => {
                if (record?.employeeNo === null || record?.employeeNo === undefined || record?.employeeNo === "") {
                    return "-";
                }
                return <span
                    style={{
                        color: "#42526D",
                        backgroundColor: "#F5F6F7",
                        borderRadius: "20px",
                        width: "max-content",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "auto",
                        padding: "8px 16px"
                    }}
                >
                    {record?.employeeNo}
                </span>;
            },
        },
        {
            title: <div className="text-table">{t('name-surname')}</div>,
            dataIndex: "name",
            key: "name",
            align: "left",
            render: (_, record) => {
                return (record?.name ?
                    (i18n.language === "en" ? record?.nameEn + " " + record?.surNameEn : record?.name + " " + record?.surName) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t("identification-no")}</div>,
            dataIndex: "idCard",
            key: "idCard",
        },
        {
            title: <div className="text-table">{t('department')}</div>,
            dataIndex: "department",
            key: "department",
            align: "left",
            render: (_, record) => {
                return (
                    record?.department?.id ? (i18n.language === "en" ? record?.department?.organizationNameEn : record?.department?.organizationName) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('report.position')}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            render: (_, record) => {
                return (
                    record?.position?.id ? (i18n.language === "en" ? record?.position?.positionNameEn : record?.position?.positionName) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t("employee.label.salary")}</div>,
            dataIndex: "salary",
            key: "salary",
            align: "right",
            render: (_, record) => {
                return (
                    record?.salary ? get2DecimalPointsWithCommas(record?.salary) : "-"
                )
            }
        },
        {
            title: <div className="text-table">{t("report.label.employee_contribution")}</div>,
            dataIndex: "employeeContribution",
            key: "employeeContribution",
            align: "right",
            render: (_, record) => {
                return (
                    record?.employeeContribution ? get2DecimalPointsWithCommas(record?.employeeContribution) : "-"
                )
            }
        },
        {
            title: <div className="text-table">{t("report.label.employer_contribution")}</div>,
            dataIndex: "employerContribution",
            key: "employerContribution",
            align: "right",
            render: (_, record) => {
                return (
                    record?.employerContribution ? get2DecimalPointsWithCommas(record?.employerContribution) : "-"
                )
            }
        }
    ]
    return (
        <MainLayout>
            <SSOPaymentReportModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} exportSSOPayrollReport={exportSSOPayrollReport} />
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("report.header"), href: "" },
                        { title: t("salary_calculation_group.header"), href: "" },
                        { title: t("sso_payment.header") }
                    ]} />
                    <h2>{t("sso_payment.header")}</h2>
                </Flex>

                <FormAntd onFinish={handleSearch}>
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card
                                        style={{
                                            backgroundColor: "white",
                                            width: "100%",
                                            marginBottom: "1vw",
                                            border: "1px solid #EAECF0",
                                        }}
                                    >
                                        <Flex vertical gap={16}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t("name-surname")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormSelect
                                                        name="departmentId"
                                                        label={t('employee.label.department')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="positionId"
                                                        label={t('position.header')}
                                                        options={positionOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="month"
                                                        label={t('month_year')}
                                                        style={{ width: '100%', }}
                                                        placeholder={t('month_year')}
                                                        size="large"
                                                        picker="month"
                                                        dateFormat="MMMM"
                                                        required
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormSelect
                                                        name="branchId"
                                                        label={t('employee.label.branch')}
                                                        options={branchOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        required
                                                        mode="multiple"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px", marginTop: "24px" }}>
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>

                                    {showReport && (
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Flex justify="end">
                                                <Button type="default" style={{ height: "40px", borderRadius: "8px" }}
                                                    onClick={showModal}
                                                >
                                                    <Flex gap={8}>
                                                        <DownloadIcon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>

                                            <TableAntd
                                                columns={columns}
                                                dataSource={reportSSOPayrollList}
                                                onChange={onChange}
                                                pagination={pagination}
                                            />
                                        </Space>
                                    )}
                                </>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout>
    )
}

export default SSOPaymentReportComponent;